export const WalletMovementsListSkeleton = () => (
  <div className="flex animate-pulse flex-col gap-3">
    <div className="rounded-2xl bg-gray-200 p-6" style={{ height: 120 }} />

    {[1, 2, 3, 4].map(i => (
      <div
        key={i}
        className="flex flex-col gap-3 rounded-xl bg-white p-4 shadow-sm"
      >
        <div className="flex justify-between gap-2">
          <span className="block h-5 w-20 rounded-full bg-gray-200" />
          <span className="block h-4 w-24 rounded bg-gray-200" />
        </div>
        <span className="block h-4 w-full rounded bg-gray-200" />
        <span className="block h-4 w-4/5 rounded bg-gray-200" />
        <div className="flex justify-end gap-2">
          <span className="block h-5 w-16 rounded bg-gray-200" />
          <span className="block h-5 w-16 rounded bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
)
